<template>
    <div class="container">
    <div class="row">
        <div class="col">
            <button type="button" class="btn btn-warning ms-2 float-end"
                    @click="goBack">
                <font-awesome-icon :icon="faChevronLeft" /> Kembali
            </button>
        </div>
    </div>
    <div class="row mb-5">
        <div class="col-md-6">
            <div class="mb-3 d-block">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeOffice" id="typeOfficeBulan" v-model="typeByOffice" value="bulan">
                    <label class="form-check-label" for="typeOfficeBulan">Bulan</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeOffice" id="typeOfficeYear" v-model="typeByOffice" value="year">
                    <label class="form-check-label" for="typeOfficeYear">Tahun</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeOffice" id="typeOfficeTarikh" v-model="typeByOffice" value="tarikh">
                    <label class="form-check-label" for="typeOfficeTarikh">Tarikh</label>
                </div>
            </div>
            <div class="d-inline-block">
            <div class="d-flex mb-3" v-if="typeByOffice ==='tarikh'">
                <VueDatePicker v-model="dateFromByOffice" :auto-position="true"
                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                               placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block me-2" style="max-width: 250px"></VueDatePicker>
                <span class="d-block me-2 my-1">hingga</span>
                <VueDatePicker v-model="dateToByOffice" :auto-position="true"
                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                               placeholder="Tarikh akhir" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block" style="max-width: 250px"></VueDatePicker>
            </div>
            </div>
            <div class="d-inline-block mb-3" v-if="typeByOffice ==='bulan'">
                <select class="form-select d-inline-block" style="width: 120px" v-model="monthSelectedByOffice">
                    <option v-for="m in monthRange" :value="m" class="text-center">{{ m }}</option>
                </select>
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelectedByOffice">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <div class="d-inline-block mb-3" v-if="typeByOffice ==='year'">
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelectedByOffice">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <button type="button" class="btn btn-primary ms-2" @click="getDataByOffice()">Cari
            </button>
            <p v-if="pejabatData.length > 0" class="fs-6"><i><sup>*</sup>Bilangan <b>pewakaf sebenar</b> adalah <b>{{ sumFormatWithoutDecimal(pewakafSebenarSemua)}}</b> </i></p>
            <p v-if="pejabatData.length > 0" class="fs-6"><i><sup>*</sup>Bilangan <b>pewakaf baru</b> adalah <b>{{ sumFormatWithoutDecimal(pewakafBaruSebenarSemua)}}</b></i></p>
            <form v-if="pejabatData.length > 0" :action="uri_download_report_pejabat" method="post">
                <input type="hidden" name="_token" :value="csrf">
                <input v-if="typeByOffice === 'bulan'" type="hidden" name="month" :value="monthSelectedByOffice">
                <input v-if="typeByOffice === 'bulan' || typeByOffice === 'year'" type="hidden" name="year" :value="yearSelectedByOffice">
                <input v-if="typeByOffice === 'tarikh'" type="hidden" name="from" :value="parseDateData(dateFromByOffice)">
                <input v-if="typeByOffice === 'tarikh'" type="hidden" name="to" :value="parseDateData(dateToByOffice)">
                <input type="hidden" name="type" :value="typeByOffice">
                <button type="submit" class="btn btn-outline-success mb-3 fs-6" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
            </form>
            <div v-if="pejabatData.length > 0" class="table-responsive">
                <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Pejabat</th>
                    <th class="text-center">Transaksi</th>
                    <th class="text-center">Pewakaf</th>
                    <th class="text-center">Pewakaf baru</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in pejabatData">
                    <th scope="row">{{ index+1 }}</th>
                    <th scope="row">{{ item.NamaPejabat  }}</th>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.Transaksi) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.Pewakaf) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.PewakafBaru) }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th scope="row" colspan="2" class="text-center">JUMLAH</th>
                    <td class="text-end">{{ sumFormatWithoutDecimal(sumNumbersPejabat(pejabatData, "transaksi")) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(sumNumbersPejabat(pejabatData, "pewakaf")) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(sumNumbersPejabat(pejabatData, "pewakafbaru")) }}</td>
                </tr>
                </tfoot>
            </table>
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3 d-block">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeProject" id="bulanProject" v-model="typeByProject" value="bulan">
                    <label class="form-check-label" for="bulanProject">Bulan</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeProject" id="yearProject" v-model="typeByProject" value="year">
                    <label class="form-check-label" for="yearProject">Tahun</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="typeProject" id="tarikhProject" v-model="typeByProject" value="tarikh">
                    <label class="form-check-label" for="tarikhProject">Tarikh</label>
                </div>
            </div>
            <div class="d-inline-block">
                <div class="d-flex mb-3" v-if="typeByProject ==='tarikh'">
                    <VueDatePicker v-model="dateFromByProject" :auto-position="true"
                                   :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                   placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block me-2" style="max-width: 250px"></VueDatePicker>
                    <span class="d-inline-block me-2 my-1">hingga</span>
                    <VueDatePicker v-model="dateToByProject" :auto-position="true"
                                   :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms"
                                   placeholder="Tarikh akhir" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block" style="max-width: 250px"></VueDatePicker>
                </div>
            </div>
            <div class="d-inline-block mb-3" v-if="typeByProject ==='bulan'">
                <select class="form-select d-inline-block" style="width: 120px" v-model="monthSelectedByProject">
                    <option v-for="m in monthRange" :value="m" class="text-center">{{ m }}</option>
                </select>
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelectedByProject">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <div class="d-inline-block mb-3" v-if="typeByProject ==='year'">
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelectedByProject">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <button type="button" class="btn btn-primary ms-2" @click="getDataByProject()">Cari
            </button>
            <p v-if="reportDataProject.length > 0"><i><sup>*</sup>Bilangan <b>pewakaf sebenar</b> adalah <b>{{ sumFormatWithoutDecimal(pewakafSebenarProjek)}}</b> </i></p>
            <p v-if="reportDataProject.length > 0"><i><sup>*</sup>Bilangan <b>pewakaf baru</b> adalah <b>{{ sumFormatWithoutDecimal(pewakafBaruSebenarProjek)}}</b></i></p>
            <form v-if="reportDataProject.length > 0" :action="uri_download_report_project" method="post">
                <input type="hidden" name="_token" :value="csrf">
                <input v-if="typeByProject === 'bulan'" type="hidden" name="month" :value="monthSelectedByProject">
                <input v-if="typeByProject === 'bulan' || typeByProject === 'year'" type="hidden" name="year" :value="yearSelectedByProject">
                <input v-if="typeByProject === 'tarikh'" type="hidden" name="from" :value="parseDateData(dateFromByProject)">
                <input v-if="typeByProject === 'tarikh'" type="hidden" name="to" :value="parseDateData(dateToByProject)">
                <input type="hidden" name="type" :value="typeByProject">
                <button type="submit" class="btn btn-outline-success mb-3 fs-6" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
            </form>
            <div v-if="reportDataProject.length > 0" class="table-responsive">
                <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Projek</th>
                    <th>Transaksi</th>
                    <th class="text-end">Pewakaf</th>
                    <th class="text-end">Pewakaf baru</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in reportDataProject" :key="item.nama">
                    <th scope="row">{{ index + 1 }}</th>
                    <th scope="row">{{ item.nama }}</th>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.Transaksi) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.Pewakaf) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(item.PewakafBaru) }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th scope="row" colspan="2" class="text-center">JUMLAH</th>
                    <td class="text-end">{{ sumFormatWithoutDecimal(calculateColumnBilSum(reportDataProject,"transaksi")) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(calculateColumnBilSum(reportDataProject,"pewakaf")) }}</td>
                    <td class="text-end">{{ sumFormatWithoutDecimal(calculateColumnBilSum(reportDataProject,"pewakafbaru")) }}</td>
                </tr>
                </tfoot>
            </table>
            </div>
        </div>
    </div>
    </div>
</template>

<script setup lang="ts">
import {onBeforeMount, onMounted, Ref, ref} from "vue";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"
import {arrayMonth, arrayYear, sumFormatWithoutDecimal, parseDateData} from  "../../utils/utils";
import { ms } from "date-fns/locale";
import {format, formatISO} from "date-fns";
import { type Pejabat} from "../interface/report/transaksibilangan/Pejabat";
import { type Projek} from "../interface/report/transaksibilangan/Projek";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel} from "@fortawesome/free-solid-svg-icons";
library.add(faChevronLeft);

const data = defineProps<{
    uri_get_pewakaf_office: string,
    uri_download_report_pejabat: string,
    uri_get_pewakaf_project: string,
    uri_download_report_project: string,
    month: number,
    year: number,
    csrf: string,
}>();

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();
const pejabatData = ref<Pejabat[]>([]);
const pewakafSebenarSemua = ref<number>(0);
const pewakafBaruSebenarSemua = ref<number>(0);
const pewakafSebenarProjek = ref<number>(0);
const pewakafBaruSebenarProjek = ref<number>(0);

const typeByOffice: Ref = ref<string>("bulan");
const typeByProject: Ref = ref<string>("bulan");
const reportDataProject: Ref = ref<Projek[]>([]);
const yearSelectedByOffice: Ref = ref<number>();
const monthSelectedByOffice: Ref = ref<number>();
const yearSelectedByProject: Ref = ref<number>();
const monthSelectedByProject: Ref = ref<number>();
const yearRange: Ref = ref<number[]>();
const monthRange: Ref = ref<number[]>();
const dateFromByOffice: Ref = ref<string>();
const dateToByOffice: Ref = ref<string>();
const dateFromByProject: Ref = ref<string>();
const dateToByProject: Ref = ref<string>();
const hasFinish: Ref = ref<{pejabat: boolean, projek: boolean}>(
    {pejabat: false, projek: false},
);

onBeforeMount(() => {
    getDataByOffice();
    getDataByProject();
    yearRange.value = arrayYear(data.year);
    monthRange.value = arrayMonth();
});

onMounted(() => {
    monthSelectedByOffice.value = data.month;
    yearSelectedByOffice.value = data.year;
    monthSelectedByProject.value = data.month;
    yearSelectedByProject.value = data.year;
});

const getDataByOffice = (): void => {
    emitToParent("showLoader");
    const fd = new FormData();
    fd.set("csrf",data.csrf);
    if(typeByOffice.value === "bulan"){
        let month: string;
        let year: string;
        if(monthSelectedByOffice.value === undefined && yearSelectedByOffice.value === undefined){
            month = format(new Date(),"M");
            year = format(new Date(),"y");
        }
        else{
            month = monthSelectedByOffice.value + "";
            year = yearSelectedByOffice.value + "";
        }
        fd.set("month", month); //formdata only accept blob or string
        fd.set("year",year); //formdata only accept blob or string
    }
    else if (typeByOffice.value === "year"){
        let year: string;
        if(yearSelectedByOffice.value === undefined){
            year = format(new Date(),"y");
        }
        else{
            year = yearSelectedByOffice.value + "";
        }
        fd.set("year",year); //formdata only accept blob or string
    }
    else if (typeByOffice.value === "tarikh"){
        if(dateFromByOffice.value !== undefined && dateFromByOffice.value !== null){
            fd.set("from", formatISO(new Date(dateFromByOffice.value))); //formdata only accept blob or string
        }
        if(dateToByOffice.value !== undefined && dateToByOffice.value !== null){
            fd.set("to", formatISO(new Date(dateToByOffice.value))); //formdata only accept blob or string
        }
    }
    axios({
        method: "post",
        url: data.uri_get_pewakaf_office,
        data: fd,
        headers: {"Content-Type": "application/json"}
    }).then(function (response) {
        pejabatData.value = response.data[0];
        pewakafSebenarSemua.value = response.data[1][0].BilSebenarProjekDanUmum;
        pewakafBaruSebenarSemua.value = response.data[2][0].BilSebenarPewakafBaruKesemuaProjekDanUmum;
        hasFinish.value.pejabat = true;
        if(hasFinish.value.projek === true){
            emitToParent("hideLoader");
        }
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk hantar. " + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

const getDataByProject = () : void => {
    emitToParent("showLoader");
    const fd = new FormData();
    fd.set("csrf",data.csrf);
    if(typeByProject.value === "bulan"){
        let month: string;
        let year: string;
        if(monthSelectedByProject.value === undefined && yearSelectedByProject.value === undefined){
            month = format(new Date(),"M");
            year = format(new Date(),"y");
        }
        else{
            month = monthSelectedByProject.value + "";
            year = yearSelectedByProject.value + "";
        }
        fd.set("month", month); //formdata only accept blob or string
        fd.set("year",year); //formdata only accept blob or string
    }
    else if (typeByProject.value === "year"){
        let year: string;
        if(yearSelectedByProject.value === undefined){
            year = format(new Date(),"y");
        }
        else{
            year = yearSelectedByProject.value + "";
        }
        fd.set("year",year); //formdata only accept blob or string
    }
    else if (typeByProject.value === "tarikh"){
        if(dateFromByProject.value !== undefined && dateFromByProject.value !== null){
            fd.set("from", formatISO(new Date(dateFromByProject.value))); //formdata only accept blob or string
        }
        if(dateToByProject.value !== undefined && dateToByProject.value !== null){
            fd.set("to", formatISO(new Date(dateToByProject.value))); //formdata only accept blob or string
        }
    }
    axios({
        method: "post",
        url: data.uri_get_pewakaf_project,
        data: fd,
        headers: {"Content-Type": "application/json"}
    }).then(function (response) {
        reportDataProject.value = response.data[0];
        pewakafSebenarProjek.value = response.data[1][0].BilSebenarPewakafKesemuaProjek;
        pewakafBaruSebenarProjek.value = response.data[2][0].BilSebenarPewakafBaruKesemuaProjek;
        hasFinish.value.projek = true;
        if(hasFinish.value.pejabat === true){
            emitToParent("hideLoader");
        }
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk hantar. "+ error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

const calculateColumnBilSum = (projeks: Projek[],type: string) : number =>{
    let sum: number = 0;
    for(let i=0; i < projeks.length; i++){
        if(type === "transaksi")
            sum+= projeks[i].Transaksi;
        else if (type === "pewakaf")
            sum+= projeks[i].Pewakaf;
        else if (type === "pewakafbaru")
            sum+= projeks[i].PewakafBaru;
    }
    return sum;
}
const sumNumbersPejabat = (pejabats: Pejabat[], column: string): number => {
    let sum: number = 0;
    for(let i = 0; i < pejabats.length; i++){
        if(column === "transaksi"){
            sum+= pejabats[i].Transaksi;
        } else if(column === "pewakaf"){
            sum+= pejabats[i].Pewakaf;
        }else if(column === "pewakafbaru"){
            sum+= pejabats[i].PewakafBaru;
        }
    }
    return sum;
}

const goBack = (): void => {
    emitToParent("hidePage", true);
}

</script>
